import type { CreateWorkflowInput, UpdateWorkflowInput } from '@idc-forms/schemas'
import { axiosPrivate } from '@/shared/api/axios'
import { buildListQueryString } from '@/shared/api/build-list-query-string'
import { API } from '@/shared/constants/api'
import type {
  PaginatedWorkflows,
  WorkflowAdminRow,
  WorkflowsAdminParams
} from '../models/workflow-admin'

export async function getWorkflowsAdmin(params: WorkflowsAdminParams): Promise<PaginatedWorkflows> {
  const qs = buildListQueryString(params)
  const { data } = await axiosPrivate.get<PaginatedWorkflows>(
    `${API.workflows.root}${qs ? `?${qs}` : ''}`
  )
  return data
}

/** Los payloads son los MISMOS schemas Zod que valida el backend. */
export async function createWorkflow(payload: CreateWorkflowInput): Promise<WorkflowAdminRow> {
  const { data } = await axiosPrivate.post<WorkflowAdminRow>(API.workflows.root, payload)
  return data
}

export async function updateWorkflow(
  id: string,
  payload: UpdateWorkflowInput
): Promise<WorkflowAdminRow> {
  const { data } = await axiosPrivate.patch<WorkflowAdminRow>(API.workflows.byId(id), payload)
  return data
}

export async function deleteWorkflow(id: string) {
  const { data } = await axiosPrivate.delete(API.workflows.byId(id))
  return data
}
